import React from 'react';

const AppHeaderContext = React.createContext();
export default AppHeaderContext;
